<!-- src/components/Suggestions.vue -->
<template>
    <div>
        <a-form :model="form" layout="vertical">
            <a-form-item label="建议：">
                <a-textarea v-model="form.desc" :rows="9" placeholder="请输入您的建议" />
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSubmit">提交</a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
import { defineComponent, reactive } from 'vue';
import { Message } from '@arco-design/web-vue';
import { postSuggestion } from "@/api/home";

export default defineComponent({
    name: "Suggestions",
    setup() {
        const form = reactive({
            desc: ''
        });

        const onSubmit = async () => {
            if (!form.desc.trim()) {
                Message.warning('请输入您的建议内容');
                return;
            }

            const payload = {
                suggestion: form.desc
            };

            try {
                const res = await postSuggestion(payload);
                if (res.code === 200) {
                    Message.success("建议发送成功");
                    form.desc = '';
                }
            } catch (error) {
                Message.error(error.msg || '发送失败');
            }
        };

        return {
            form,
            onSubmit,
        };
    }
});
</script>

<style scoped>
/* 可根据需要添加样式 */
</style>
